module.exports = __webpack_public_path__ + "img/kv.e94f91c1.png";